import { Alerts, Brand, Neutrals, Theme } from './colors';

export const Stroke = {
  StrokeThickness: {
    StrokeThicknessDefault: 1,
    StrokeThicknessSelected: 2,
  },
  StrokeDashed: {
    StrokeDashedDefault: {
      borderWidth: 1,
      borderStyle: 'dashed',
    },
    StrokeDashedSelected: {
      borderWidth: 2,
      borderStyle: 'dashed',
    },
  },
  StrokeColor: {
    StrokeColorNeutral: Neutrals.neutralGreys.GreyNatural150,
    StrokeColorBrand: Neutrals.coldGreys.GreyCold200,
    StrokeColorActive: Theme.main.ThemeWater,
    StrokeColorDisabled: Neutrals.neutralGreys.GreyNatural050,
    StrokeColorDelivery: Brand.iris.Iris500,
    StrokeColorPromo: Brand.orange.Orange500,
    StrokeColorError: Alerts.Red500,
  },
};
